const initialState = {
  busy            : true,
  dl_busy         : false,
  current_limit   : 30,
  files           : [],
  queues          : [],
  dirs            : {},

  selection : {
    size  : 0,
    cost  : 0,
    count : 0
  }
}

export default function localFilesSystem(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
